

export const DeleteBookingModalStyles = () => {
    return {
        modal: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '35vw',
            height: '25vh',
            minHeight: '25vh',
            minWidth: '35vw',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            outline: 'none',
            borderRadius: '1rem',
            padding: '0px !important',
            alignItems: 'center',
            justifyContent: 'center',
          },
        filterHeader: {
            borderRadius: '1rem',
            display: 'block',
            alignItems:'center',
            padding: '1.5rem',
            marginBottom: '1.5rem',
            justifyContent: 'space-between'
        },
        searchButton: {
            backgroundColor: '#0b1339',
            textTransform: 'none',
            color: '#fff',
            borderRadius: '2rem',
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
            fontSize: '0.8rem',
            '&:hover': {
                backgroundColor: '#0b1339'
              }
          }

    }
}